// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { TraitValueModel, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
// import Swatch, { SwatchTypeValues } from "@insite/mobius/Swatch"; // Starter Custom Code
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import styled, { css } from "styled-components";

/* Starter Custom Code - Start */
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import Swatch, { SwatchTypeValues } from "@store/MobiusOverrides/Swatch/Swatch";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { swatchListItemStyles, swatchListStyles } from "@store/Themes/common/mixins/swatch";
import { productCardProps } from "@store/Themes/common/props/productCard";
import { swatchProps } from "@store/Themes/common/props/swatch";
import useSwatchSelectedAccessibleText from "@toolkit/Framework/Common/Hooks/useSwatchSelectedAccessibleText";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Starter Custom Code - End */

interface Props {
    product: ProductContextModel;
    variantTrait: VariantTraitModel;
}

export interface ProductListVariantSwatchStyles {
    container?: InjectableCss;
    swatchClickable?: ClickablePresentationProps;
    labelText?: TypographyPresentationProps;
    labelWrapper?: InjectableCss;
    productDetailLink?: LinkPresentationProps;
}

export const productListVariantSwatchStyles: ProductListVariantSwatchStyles = {
    container: productCardProps.actionsWrapper,
    swatchClickable: swatchProps.clickable,
    labelText: {
        css: css`
            display: block;
            margin-bottom: ${pxToRem(2)};
            font-size: ${x => x.theme.design.typography.size.small};
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
};

const SwatchGridDisplayItem = styled.li`
    ${swatchListItemStyles() /* Starter Custom Code */}
`;

const SwatchGridDisplayViewMore = styled.li`
    ${swatchListItemStyles() /* Starter Custom Code */}
    ${linkActionStyles() /* Starter Custom Code */}
`;

export const UnorderedList = styled.ul<InjectableCss>`
    ${swatchListStyles() /* Starter Custom Code */}
    ${injectCss}
`;

const styles = productListVariantSwatchStyles;

const ProductListVariantSwatch = ({ product, variantTrait }: Props) => {
    const swatchSelectedAccessibleText = useSwatchSelectedAccessibleText(variantTrait); // Starter Custom Code

    const CreateSwatchGrid = (traitValue: TraitValueModel) => {
        return (
            <SwatchGridDisplayItem key={traitValue.id} title={traitValue.valueDisplay /* Starter Custom Code */}>
                <Swatch
                    type={traitValue.swatchType as SwatchTypeValues}
                    value={
                        traitValue.swatchType === SwatchTypeValues.Image
                            ? traitValue.swatchImageValue
                            : traitValue.swatchColorValue
                    }
                    size={20}
                    // Starter Removed - isDisabled
                    isSelected={traitValue.isDefault}
                    // Starter Custom Code
                    caption={traitValue.valueDisplay}
                    hideCaption
                />
            </SwatchGridDisplayItem>
        );
    };

    const ViewMoreLink = (product: ProductContextModel) => {
        const productDetailPath = product.productInfo.productDetailPath;

        return (
            <SwatchGridDisplayViewMore data-test-selector="swatch_viewMore">
                <Link
                    {...styles.productDetailLink}
                    href={productDetailPath}
                    // Starter Removed - alt
                    data-test-selector="swatch_ProductDescriptionLink"
                >
                    {translate("View More")}
                    {/* Starter Custom Code - Start */}
                    <VisuallyHidden>{variantTrait.nameDisplay}</VisuallyHidden>
                    {/* Starter Custom Code - End */}
                </Link>
            </SwatchGridDisplayViewMore>
        );
    };

    return (
        <StyledWrapper
            key={variantTrait.id}
            data-test-selector="swatch_productListProductSwatchList"
            {...styles.container}
        >
            <StyledWrapper {...styles.labelWrapper}>
                <Typography {...styles.labelText}>
                    {variantTrait.nameDisplay}
                    {/* Starter Custom Code - Start */}
                    {swatchSelectedAccessibleText && <VisuallyHidden>{swatchSelectedAccessibleText}</VisuallyHidden>}
                    {/* Starter Custom Code - End */}
                </Typography>
            </StyledWrapper>
            <UnorderedList>
                {variantTrait.traitValues
                    ?.slice(0, variantTrait.numberOfSwatchesVisible)
                    .map(traitValue => CreateSwatchGrid(traitValue))}
                {variantTrait &&
                    variantTrait.traitValues &&
                    variantTrait.numberOfSwatchesVisible < variantTrait.traitValues?.length &&
                    ViewMoreLink(product)}
            </UnorderedList>
        </StyledWrapper>
    );
};

export default ProductListVariantSwatch;
